import React from "react";
import { getRoute, routeParam } from "utilities/route";
import { PickSlipContest } from "./PickSlipContest";
import { PickSlipNoContest } from "./PickSlipNoContest";

const PickSlip = () => {
  const contestParam = routeParam(getRoute(), "contest");

  if (contestParam) {
    return <PickSlipContest />;
  } else {
    return <PickSlipNoContest />;
  }
};

export { PickSlip };
